import { render, staticRenderFns } from "./References.vue?vue&type=template&id=d12c91c8&lang=pug&"
import script from "./References.vue?vue&type=script&lang=js&"
export * from "./References.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d12c91c8')) {
      api.createRecord('d12c91c8', component.options)
    } else {
      api.reload('d12c91c8', component.options)
    }
    module.hot.accept("./References.vue?vue&type=template&id=d12c91c8&lang=pug&", function () {
      api.rerender('d12c91c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/docs/References.vue"
export default component.exports